import React from 'react';
import { render } from 'react-dom';
import { I18nextProvider } from 'react-i18next';

import { default as App } from './components/App';
import withOptConfig from '../shared/optConfig';
import AnalyticsService from '../shared/services/AnalyticsService';
import I18n from '../shared/I18n';

export function initGa (...args) {
  AnalyticsService.initGa(...args);
}

export function renderFindADoctor(element, dictionary, lang) {
  AnalyticsService.sendPageVisit('Find a Doctor', 'DTC');

  I18n.initialize(dictionary, lang);
  const AppWithConfig = withOptConfig(App, element);
  render(
    (
      <I18nextProvider i18n={I18n.i18n}>
        <AppWithConfig />
      </I18nextProvider>
    ), element,
  );
}
